export const CAR_CHOICE_ACCEPTED = 'accepted'
export const CAR_CHOICE_ACCEPTED_WITH_REPRICE = 'accepted_with_reprice'
export const CARS_BOOKED_NOT_INTERESTED = 'not_interested'
